import axios from "axios";
import env from "../../variables/config";

axios.defaults.baseURL = env.apiUrl;

const config = () => ({
    headers: { Authorization: "Bearer " + localStorage.getItem("token") }
});

export interface AdminSignalFilters {
    eventType?: string;
    importance?: string;
    company?: string;
    search?: string;
    tags?: string[];
    isActive?: string;
    includeExpired?: boolean;
    sortBy?: string;
    order?: string;
    page?: number;
    limit?: number;
}

// Get all signals (admin view)
export const getAdminSignals = async (filters?: AdminSignalFilters) => {
    const params = new URLSearchParams();
    if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                if (Array.isArray(value)) {
                    value.forEach(v => params.append(key, v));
                } else {
                    params.append(key, value.toString());
                }
            }
        });
    }
    const res = await axios.get(`/admin/signals?${params.toString()}`, config());
    return res.data;
};

// Get a specific signal (admin)
export const getAdminSignal = async (id: string) => {
    const res = await axios.get(`/admin/signals/${id}`, config());
    return res.data;
};

// Create a new signal (admin)
export const createAdminSignal = async (data: any) => {
    const res = await axios.post('/admin/signals', data, config());
    return res.data;
};

// Update a signal (admin)
export const updateAdminSignal = async (id: string, data: any) => {
    const res = await axios.put(`/admin/signals/${id}`, data, config());
    return res.data;
};

// Delete a signal (admin)
export const deleteAdminSignal = async (id: string) => {
    const res = await axios.delete(`/admin/signals/${id}`, config());
    return res.data;
};

// Batch create signals (admin)
export const batchCreateSignals = async (signals: any[]) => {
    const res = await axios.post('/admin/signals/batch', { signals }, config());
    return res.data;
};

// Toggle signal active status (admin)
export const toggleSignalActive = async (id: string) => {
    const res = await axios.patch(`/admin/signals/${id}/toggle-active`, {}, config());
    return res.data;
};

// Get admin stats
export const getAdminSignalStats = async () => {
    const res = await axios.get('/admin/signals/stats/admin', config());
    return res.data;
};
